<template>
    <Loader />
    <!-- <form v-else action="https://auth.zynoapi.net/proxy-oidc/start" method="POST" @submit="doLogin">
        <input type="hidden" name="returnUrl" :value="returnUrl" />
        <input type="email" name="email" placeholder="e-mail address" v-autofocus />
        <button type="submit">Login</button>
    </form> -->
</template>

<script lang="ts" setup>
import { dataFrom, OpenApiError } from '@zyno-io/openapi-client-codegen';
import { formatError } from '@zyno-io/vue-foundation';
import { onMounted } from 'vue';

import { IdentityApi, MetaApi } from '@/generated/openapi-client';
import Loader from '@/shared/components/loader.vue';
import { Auth } from '@/shared/services/auth';
import { useStore } from '@/store';

const store = useStore();

onMounted(async () => {
    try {
        const response = await fetch(import.meta.env.VITE_APP_JWT_URL, {
            redirect: 'manual',
            credentials: 'include'
        });

        if (response.type === 'opaqueredirect' && location.host.startsWith('localhost')) {
            store.globalError = 'Please sign into https://agentapp.c2cfsi.com first.';
            return;
        }

        if (!response.ok) {
            throw new Error(`HTTP request failed with status ${response.status}`);
        }

        const { jwt } = await response.json();
        Auth.setJwt(jwt);

        const identity = dataFrom(await IdentityApi.getIdentityGetIdentity());
        store.user = identity;

        store.config = dataFrom(await MetaApi.getMetaGetConfig());
    } catch (err) {
        store.globalError =
            err instanceof OpenApiError && err.response?.status === 401 ? 'You are not authorized to access this system.' : formatError(err);
    }
});
</script>

<style lang="scss" scoped>
form {
    @apply w-96 bg-gray-100 p-2 rounded-md flex gap-1;

    input {
        @apply flex-1;
    }
}
</style>
